<div class="loading-overlay" *ngIf="ajaxRequest || routing">
  <div class="loading-overlay__spinner"></div>
  <div class="loading-overlay__text" *ngIf="text">
    {{ text }}
  </div>
</div>
